
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "HomeInfo",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "api/AnonymousForm/loadForm",
      apiSaveMethod: "",
      form: "HomeInfo",
      page: "HomeInfoDaten",
      remoteId: "",
      waitForResponse: true
      

    });

    return {
      request
    };
  }
};
